import React from 'react';
import MembersManagementPage from '../../members/MembersManagementPage';
import { AP_COPY } from '../adminPersonnelCopy';
import { AdminPersonnelPageHeader } from '../ui';

export default function AdminPersonnelMembersPage() {
  return (
    <MembersManagementPage
      copy={AP_COPY.MEMBERS}
      badge={AP_COPY.DASHBOARD.BADGE}
      PageHeader={AdminPersonnelPageHeader}
      rootClassName="ap-dash"
      shellClassName="ap-shell"
      createBtnClassName="ap-create-btn"
    />
  );
}
